export enum ProjectStatus {
	PROSPECT = 'PROSPECT',
	DELIVERED = 'DELIVERED',
	IN_PROGRESS = 'IN_PROGRESS',
	ARCHIVED = 'ARCHIVED',
}
